import React, {Component} from 'react';
import AppStore from './stores/AppStore';
import connectToStores from 'alt-utils/lib/connectToStores';
import NotificationSystem from 'react-notification-system';
import notifier from './lib/notifier';
import Menu from "./components/Menu";
import * as selectn from "selectn";
import {Route} from "react-router-dom";
import {Home} from './components/Home';
import {Items} from "./components/Items";
import {HealthAndSafety} from "./components/HealthAndSafety";
import {Item} from "./components/Item";
import {Incident} from "./components/Incident";
import {withRouter} from 'react-router-dom';
import {HealthAndSafetyData} from "./components/HealthAndSafetyData";
import {HealthAndSafetySync} from "./components/HealthAndSafetySync";
import {SpatialAnchors} from "./components/SpatialAnchors";
import {SpatialAnchor} from "./components/SpatialAnchor";

class App extends Component {
    static getStores() {
        return [AppStore];
    }

    static getPropsFromStores() {
        return {
            state: AppStore.getState()
        };
    }

    render() {
        const pathname = selectn('location.pathname', this.props);

        return (
            <div>
                <NotificationSystem
                    ref={(notificationSystem) => notificationSystem && notifier.initialize(notificationSystem)}/>
                <Menu
                    pathname={pathname}/>

                <Route exact={true} path={'/'} render={(props) => <Home {...props} {...this.props.state} />}/>
                <Route exact={true} path={'/spatial-anchors'} render={(props) => <SpatialAnchors {...props} {...this.props.state} />}/>
                <Route exact={true} path={'/spatial-anchor/:id'} render={(props) => <SpatialAnchor {...props} {...this.props.state} />}/>
                <Route exact={true} path={'/items'} render={(props) => <Items {...props} {...this.props.state} />}/>
                <Route exact={true} path={'/item/:id'} render={(props) => <Item {...props} {...this.props.state} />}/>
                <Route exact={true} path={'/health-and-safety'} render={(props) => <HealthAndSafety {...props} {...this.props.state} />}/>
                <Route exact={true} path={'/health-and-safety-data'} render={(props) => <HealthAndSafetyData {...props} {...this.props.state} />}/>
                <Route exact={true} path={'/health-and-safety-sync'} render={(props) => <HealthAndSafetySync {...props} {...this.props.state} />}/>
                <Route exact={true} path={'/incident/:id'} render={(props) => <Incident {...props} {...this.props.state} />}/>

            </div>
        );
    }
}

export default withRouter(connectToStores(App));